import { getOptionFunc } from '../state';
import { requestFromApi } from './request-from-api';
export const loginToExpress = async ({ options, username, password }) => {
    const getOption = getOptionFunc(options);
    // @ts-expect-error
    const { company, url: host } = getOption('medalliaConfig');
    try {
        const loginResponse = await requestFromApi(options, {
            url: 'login',
            method: 'POST',
            data: JSON.stringify({
                company,
                host,
                password,
                username
            })
        });
        return loginResponse;
    }
    catch (err) {
        return Promise.reject(err);
    }
};
